interface IconBookingStatusBlueOptions {
    cssClasses?: string
}

export function IconBookingStatusBlue(props: IconBookingStatusBlueOptions) {
    return (
        <svg version="1.1" id="b5135b71-d5f7-47d7-bbf2-1ebf7ef76882" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;" className={props?.cssClasses}>
            <path className="st1" d="M8,0.7C4,0.7,0.7,4,0.7,8c0,4,3.3,7.3,7.3,7.3c4,0,7.3-3.3,7.3-7.3C15.3,4,12.1,0.7,8,0.7C8,0.7,8,0.7,8,0.7z"/>
            <path className="st1" d="M8,8.7v-4"/>
            <path className="st2" d="M8,10.7c-0.4,0-0.7,0.3-0.7,0.7C7.3,11.7,7.6,12,8,12c0.4,0,0.7-0.3,0.7-0.7c0,0,0,0,0,0C8.7,11,8.4,10.7,8,10.7z"/>
        </svg>
    );
}
